/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-25 10:38:27
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {MaintenanceStaticDOI} from "./api/maintenanceStaticApi";
import MaintenanceStaticService from "./service/maintenanceStaticService";
import './maintenanceStatic.less';

@Component({name: 'maintenance-static'})
export default class MaintenanceStatic extends BasicSearchPage<MaintenanceStaticService, MaintenanceStaticDOI.RowDataI, MaintenanceStaticDOI.QueryRowDataParamsI> {
    
    @override
    renderHead(h) {
        return <div></div>
    }

	@override
	loadService () {
		this.service = new MaintenanceStaticService(this)
	}
}